import { css } from "@emotion/react";
import { theme } from "styles/theme";

export const ModalDetailStyle = {
  modalStyle: css`
    position: fixed;
    width: 100% !important;
    height: 100%;
    left: 0;
    top: 0;
    max-width: 100% !important;

    .ant-modal-content {
      width: 100%;
      height: 100%;
      background-color: transparent;
      padding: 0 !important;

      .ant-modal-body {
        width: 100%;
        height: 100%;
      }
    }
  `,
  content: css`
    width: 100%;
    height: 100%;
    background-color: rgb(17 17 17 /1);
    display: flex;
    flex-direction: column;
  `,
  value: css`
    flex: 1;
    overflow: auto;
    padding: 12px;
    color: #fff;
    .date {
      font-weight: 600;
      font-size: 17px;
    }
    .content {
      color: ${theme.colors.neutrals[100]};
    }
  `,
  header: css`
    background-color: rgb(252 143 0 /1);
    padding: 10px;
    display: flex;
    flex-direction: row;
    align-items: center;

    .icon-back {
      width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      svg {
        fill: #fff;
        transform: rotate(180deg);
      }
    }
    .title {
      flex: 1;
      margin-right: 32px;
      text-align: center;
      color: #fff;
      font-size: 1.125rem;
      line-height: 1.75rem;
    }
  `,
};
